<ng-container *ngIf="!isLoading">
    <p-dropdown styleClass="no-padd sub-dropdown" optionDisabled="inactive" optionLabel="name"
        scrollHeight="200px" (onChange)="onPodsChange($event)" [autoDisplayFirst]="false"  [(ngModel)]="activePod"
        [options]="allPods" [filter]="true" [style]="{ width: '100%' }">
    </p-dropdown>
</ng-container>